<div>
  @for (color of colors; track color) {
    <div
      class="colorbox-item inline"
      [ngClass]="{ 'selected': isSelected(color) }"
      [ngStyle]="{ 'background-color': color }"
      (click)="select(color)">
    </div>
  }
</div>
